import axios from "axios";
import { getAccessJwtToken } from "../utils/app.util";

export const ax = axios.create();

ax.interceptors.request.use(async (config) => {
  // const lastAuthUser = localStorage.getItem(
  //   `CognitoIdentityServiceProvider.${process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID}.LastAuthUser`
  // );
  // const idToken = localStorage.getItem(
  //   `CognitoIdentityServiceProvider.${process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID}.${lastAuthUser}.idToken`
  // );

  const idToken = await getAccessJwtToken();
  config.baseURL = process.env.REACT_APP_API_URL || "no/api";
  config.headers.common.Authorization = `Bearer ${idToken}`;
  return config;
});
